module.exports = [
 {
  "start": 458,
  "end": 4208,
  "text": "The net curtains of the work called Administrating Eternity "
 },
 {
  "start": 4250,
  "end": 7291,
  "text": "remind me of the layering that occur in the brain. "
 },
 {
  "start": 7542,
  "end": 10417,
  "text": "Images projected onto one curtain "
 },
 {
  "start": 10542,
  "end": 12959,
  "text": "will fall apart on the ones behind. "
 },
 {
  "start": 13208,
  "end": 15417,
  "text": "They help diffuse the image in the same way "
 },
 {
  "start": 15542,
  "end": 17917,
  "text": "our memory of the past encroaches "
 },
 {
  "start": 18041,
  "end": 20250,
  "text": "on our waking consciousness."
 },
 {
  "start": 20458,
  "end": 22166,
  "text": "By walking through this work "
 },
 {
  "start": 22291,
  "end": 25291,
  "text": "the visitor becomes a projection surface."
 },
 {
  "start": 25625,
  "end": 27250,
  "text": "Most interesting are for me "
 },
 {
  "start": 27375,
  "end": 28708,
  "text": "the layers of our feelings, "
 },
 {
  "start": 28834,
  "end": 32000,
  "text": "memories thinking and instincts together."
 },
 {
  "start": 32166,
  "end": 34792,
  "text": "this installation also shows clearly "
 },
 {
  "start": 34834,
  "end": 39792,
  "text": "that the only place not to see an image distorted "
 },
 {
  "start": 39834,
  "end": 42417,
  "text": "is when we go close to the source. "
 },
 {
  "start": 42625,
  "end": 44708,
  "text": "That demonstrates if we want to be close "
 },
 {
  "start": 44750,
  "end": 47667,
  "text": "to the other we have to take and look "
 },
 {
  "start": 47708,
  "end": 49959,
  "text": "from her or his position."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room4/audio1/04_MCA Administrating Eternity.js